import { getFeature, isFeature } from 'Cloud/Application/FeaturesEs6';
import type { YearAndMonthProductIds } from 'reactApp/modules/products/products.types';

export const isMultiTariffBasicWithAdsEnabled = isFeature('multi-basic-tariffs-with-ads-enabled');

export const multiTariffBasicTariffListWithAds: YearAndMonthProductIds = getFeature('multi-tariff-basic-tariff-list-with-ads');
